import { ChangeDetectionStrategy, Component, ElementRef, OnInit } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ArrayUtilities } from "@common/lib/utilities/array-utilities";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { MeetingAgendaItemComponent } from "@org-common/lib/meetings/meeting-agenda-component-registry";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";
import { CommonTeamsUiService } from "@org-common/lib/teams/common-teams-ui.service";

@MeetingAgendaItemComponent("adapt-meeting-behaviours-agenda-item")
@Component({
    selector: "adapt-meeting-behaviours-agenda-item",
    templateUrl: "./meeting-behaviours-agenda-item.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class MeetingBehavioursAgendaItemComponent extends BaseComponent implements OnInit {
    public team?: Team;
    public readonly StewardshipWorkMeetingsEdit = CommonTeamsAuthService.EditTeamMeetings;

    public constructor(
        elementRef: ElementRef,
        private commonTeamsService: CommonTeamsService,
        private commonTeamsUiService: CommonTeamsUiService,
    ) {
        super(elementRef);
    }

    public async ngOnInit() {
        // this is a bit of a hack - on alto we always do this for the leadership, on lumia, its just the owners team
        this.team = this.isAlto
            ? await this.commonTeamsService.promiseToGetLeadershipTeam()
            : ArrayUtilities.getSingleFromArray(await this.commonTeamsService.promiseToGetActiveOwnerTeams());
    }

    @Autobind
    public showGuidance() {
        return this.commonTeamsUiService.configureTeamStewardship(this.team!);
    }
}
